import PropTypes from 'prop-types';
import { Menu, Bell, PanelLeftClose, PanelLeft } from 'lucide-react';
import Button from '../ui/Button';
import ThemeToggle from '../ui/ThemeToggle';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import UserMenu from '../auth/UserMenu.jsx';
import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../utils/cn';

const Header = ({ onMenuToggle, onSidebarToggle, sidebarCollapsed, className }) => {
  const { t } = useLanguage();

  return (
    <header className={cn(
      "bg-slate-800 border-b border-slate-700 shadow-lg w-full sticky",
      "flex items-center justify-between px-4 py-3",
      "min-h-[64px]",
      className
    )}>
      {/* Left section - Menu toggle and branding */}
      <div className="flex items-center gap-4">
        {/* Mobile menu toggle */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuToggle}
          className="lg:hidden text-white hover:bg-slate-700"
          aria-label={t('navigation.menu', 'Toggle menu')}
        >
          <Menu className="h-5 w-5" />
        </Button>
        
        {/* Desktop sidebar toggle */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onSidebarToggle}
          className="hidden lg:flex text-white hover:bg-slate-700"
          aria-label={t('navigation.sidebar', 'Toggle sidebar')}
        >
          {sidebarCollapsed ? (
            <PanelLeft className="h-5 w-5" />
          ) : (
            <PanelLeftClose className="h-5 w-5" />
          )}
        </Button>
        
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">MD</span>
          </div>
          <div className="hidden sm:block">
            <h1 className="text-lg font-semibold text-white">
              MDLZ - Frontend
            </h1>
          </div>
        </div>
      </div>

      {/* Right section - User info and actions */}
      <div className="flex items-center gap-2">
        {/* Language switcher */}
        <LanguageSwitcher 
          variant="header" 
          size="sm"
        />

        {/* Theme toggle */}
        <ThemeToggle 
          className="text-white hover:bg-slate-700" 
          variant="ghost" 
          size="icon"
        />

        {/* User menu */}
        <UserMenu />
      </div>
    </header>
  );
};

Header.propTypes = {
  onMenuToggle: PropTypes.func,
  onSidebarToggle: PropTypes.func,
  sidebarCollapsed: PropTypes.bool,
  className: PropTypes.string,
};

export default Header;